import '../Tutorial.css';
import React from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T130ClickAdd() {

    /*
  useEffect(() => {
    UserService.sendEvent('ClickAdd130');
  }, []);
     */

    const text = 'To add a card to your deck, swipe down or click on it. You can have up to 5 copies of the same card in your deck. The minimum deck size is 50 cards.';

    return (
        <div>

            <div className={'T130Right'}></div>
            <div className={'T130Top'}></div>

            <TutorialGirl position={'Right'} undressingProcess={3}/>
            <div className='tutorialContainer tutorialTopContainer120'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>

        </div>

    );
}

export default T130ClickAdd;
